import { memo, FC } from 'react';

import resets from '../../_resets.module.css';
import classes from './Footer.module.scss';
import { Pagetop } from "./Pagetop/Pagetop";
import Breadcrumbs from "./Breadcrumbs";

interface Props {
  className?: string;
}

export const Footer: FC<Props> = memo(function Footer(props) {
  return (
    <div className={classes.pageTop}>
      <Breadcrumbs />
    <Pagetop
      className={classes.pagetop}
    />
  </div>
  );
});


